<template>
  <div className="animated">
    <div class="animated fadeIn">
      <b-row class="my-2">
        <b-col>
          <h1 class="text-uppercase font-weight-bold">Órdenes de pedido</h1>
        </b-col>
        <b-col>
          <div>
            <b-form>
              <b-row>
                <b-col>
                  <label for="monthSelect">Mes</label>
                  <b-form-select
                    id="monthSelect"
                    v-model="selected.month"
                    :plain="true"
                    :options="selectOptions.months"
                    value="Seleccione..."
                  >
                  </b-form-select>
                </b-col>
                <b-col>
                  <label for="yearSelect">Año</label>
                  <b-form-select
                    id="yearSelect"
                    v-model="selected.year"
                    :plain="true"
                    :options="selectOptions.years"
                    value="Seleccione..."
                  >
                  </b-form-select>
                </b-col>
              </b-row>
            </b-form>
          </div>
        </b-col>
      </b-row>
      <v-server-table :url="url" :columns="columns" :options="options" :theme="theme" ref="table" id="dataTable">
        <template #status="row">
          <b-badge :variant="getBadgeColor(row.row.status)">{{ row.row.status }}</b-badge>
        </template>
        <template #priority="row">
          <i class="fa fa-lg fa-arrow-up text-danger" v-if="row.row.priority"></i>
          <i class="fa fa-lg fa-arrow-down text-secondary" v-else></i>
        </template>
        <template #progress="row">
          <b-progress
            :value="row.row.progress ? (row.row.progress >= 100 ? 100 : row.row.progress) : 0"
            max="100"
            show-progress
            :animated="row.row.progress < 100"
            :variant="getBadgeColor(row.row.status)"
            v-if="row.row.progress > 1"
          ></b-progress>
        </template>
        <template #actions="row">
          <b-dropdown class="btn-xs" variant="link" no-caret right>
            <template #button-content>
              <a href="#">
                <i class="fa fa-lg fa-caret-down"></i>
              </a>
            </template>
            <create-purchase-order
              :id="row.row.id"
              :op-id="row.row.id"
              :planData="row.row"
              @refresh="refreshTable"
              v-if="$store.state.user.scope.includes('puede-cambiar-prioridad-op')"
            >
              <template #modalTrigger>
                <b-dropdown-item
                  href="#"
                  @click.prevent="$bvModal.show('create-op-button' + '-' + row.row.id + '-' + row.row.id)"
                >
                  Editar OP
                </b-dropdown-item>
              </template>
            </create-purchase-order>
            <b-dropdown-item href="#" @click.prevent="$bvModal.show('pallet-list-' + row.row.id)"
              >Ver pallets</b-dropdown-item
            >
            <b-dropdown-item
              href="#"
              @click.prevent="
                $router.push({
                  name: 'procesos-crear-plan-produccion',
                  params: { purchaseOrderId: row.row.id, id: 0 }
                })
              "
              >Crear plan de producción</b-dropdown-item
            >
          </b-dropdown>
          <pallet-list :id="'pallet-list-' + row.row.id" :data="row.row" />
        </template>
        <template slot="afterFilter">
          <tr class="VueTables__no-results">
            <b-button @click.prevent="resetFilters">Limpiar filtro</b-button>
            <download-excel
              class="btn"
              :fetch="fetchData"
              :fields="json_fields"
              worksheet="OPs"
              :name="name"
              :before-generate="startDownload"
              :before-finish="finishDownload"
            >
              <b-button>Descargar</b-button>
            </download-excel>
          </tr>
          <tr class="VueTables__no-results">
            <b-form-checkbox id="exclude_completed" v-model="exclude_completed" name="exclude_completed">
              Excluir completados
            </b-form-checkbox>
          </tr>
          <tr v-if="loading" class="VueTables__no-results">
            <b-spinner v-if="loading" variant="primary" class="ml-2 mt-1" small label="Small Spinner"></b-spinner>
          </tr>
        </template>
      </v-server-table>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";
import JsonExcel from "vue-json-excel";
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";
import tableTexts from "../../../lang/tableTexts";
import PalletList from "./PalletList.vue";
import CreatePurchaseOrder from "../../comercial/CreatePurchaseOrder.vue";

numeral.locale("es");
window.axios = require("axios");

var d = new Date();

Vue.use(ServerTable);
Vue.component("downloadExcel", JsonExcel);

export default {
  name: "PurchaseOrder",
  components: {
    ServerTable,
    PalletList,
    CreatePurchaseOrder
  },
  mounted() {
    Event.$on("vue-tables.loading", () => {
      this.loading = true;
    });

    Event.$on("vue-tables.loaded", () => {
      this.loading = false;
      this.ready = true;
    });

    this.loadYear();
    this.getSelectionSet();
    moment.locale("es");
  },
  data() {
    return {
      exclude_completed: true,
      ready: false,
      loading: true,
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      json_fields: {
        Exportadora: "client_customer_name"
      },
      columns: [
        "id",
        "client_customer__name",
        "delivery_date",
        "priority",
        "plan__week",
        "plan__subplan",
        "shipment__boarding_number",
        "completed_kilograms",
        "kilograms",
        "remaining_kilograms",
        "quantity",
        "status",
        "progress",
        "actions"
      ],
      selected: {
        product: "",
        product_type: "",
        condition: "",
        month: d.getMonth() + 1,
        year: d.getFullYear()
      },
      selectOptions: {
        products: [],
        product_types: [],
        months: [
          { value: 1, text: "Enero" },
          { value: 2, text: "Febrero" },
          { value: 3, text: "Marzo" },
          { value: 4, text: "Abril" },
          { value: 5, text: "Mayo" },
          { value: 6, text: "Junio" },
          { value: 7, text: "Julio" },
          { value: 8, text: "Agosto" },
          { value: 9, text: "Septiembre" },
          { value: 10, text: "Octubre" },
          { value: 11, text: "Noviembre" },
          { value: 12, text: "Diciembre" }
        ],
        years: []
      },
      data: [],
      productSet: [],
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      options: {
        // skin: "table table-sm table-hover table-striped  table-bordered border-0 table-fixed",
        debounce: 800,
        // skin: "table table-sm table-hover border-0",
        responseAdapter: function (resp) {
          const results = resp.data.results;
          const items = [];
          for (let key in results) {
            const item = results[key];
            results[key].waybill_date = moment(results[key].waybill_date).format("DD-MM-YYYY");
            results[key].total_kilograms = numeral(parseFloat(results[key].total_kilograms));
            items.push(item);
          }

          return {
            data: items,
            count: resp.data.count
          };
        },
        rowAttributesCallback: function (row) {
          const date = moment(row.delivery_date).format("DD-MM-YYYY");
          // row.delivery_date = date;
        },

        texts: tableTexts,
        perPage: 25,
        perPageValues: [15, 25, 50, 100],
        // columnsDropdown: true,
        filterByColumn: true,
        filterable: ["client_customer__name", "plan__subplan", "status"],
        listColumns: {
          status: [
            { text: "vigente", id: "vigente" },
            { text: "cancelado", id: "cancelado" },
            { text: "completado", id: "completado" }
          ],
          client_customer_name: []
        },
        headings: {
          id: "ID",
          client_customer__name: "Cliente",
          delivery_date: "Fecha de entrega",
          priority: "Prioridad",
          plan__week: "Semana",
          plan__subplan: "Programa",
          shipment__boarding_number: "Embarque",
          completed_kilograms: "Kgs. completados",
          kilograms: "Kgs. totales",
          remaining_kilograms: "Kgs. restantes",
          quantity: "Cajas",
          status: "Estado",
          progress: "Progreso",
          actions: "Acciones"
        },
        columnsClasses: {
          completed_kilograms: "text-right",
          kilograms: "text-right",
          remaining_kilograms: "text-right",
          quantity: "text-right",
          status: "text-center",
          priority: "text-center",
          progress: "text-center",
          actions: "text-center"
        },
        initFilters: {
          status
        },
        sortable: [],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          dropdown: false,
          chunk: 10
        }
      }
    };
  },
  watch: {
    selected: {
      handler(val) {
        console.log(val);
      },
      deep: true
    },
    url(val, oldVal) {
      console.log(val);
      // this.$refs.table.refresh();
    }
  },
  computed: {
    name() {
      return "Ops " + moment(Date.now()).format("YYYYMMDD h:mm") + ".xls";
    },
    url() {
      return (
        "/api/v1/purchase_order/?" +
        "month=" +
        this.selected.month +
        "&year=" +
        this.selected.year +
        "&exclude_completed=" +
        this.exclude_completed
      );
    }
  },
  methods: {
    async togglePriority(id) {
      try {
        await this.$axios.put("/api/v1/purchase_order/" + id + "/toggle_priority/");
      } catch (error) {
        console.log(error);
      } finally {
        this.$refs.table.refresh();
      }
    },
    randomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    },
    sumColumn(column) {
      let total = 0;
      const data = this.$refs.table;
      if (data) {
        total += data.data.reduce((acc, item) => acc + parseFloat(item[column]), 0);
      }
      return total;
    },
    resetFilters() {
      for (var key in this.$refs["table"].query) {
        this.$refs["table"].query[key] = "";
      }
      this.$refs["table"].refresh();
    },
    refreshTable() {
      this.$refs.table.refresh();
    },
    async fetchData() {
      const response = await this.$axios.get(this.url);
      return response.data.results;
    },
    startDownload() {
      this.loading = true;
    },
    finishDownload() {
      this.loading = false;
    },
    getBadgeColor(status) {
      // vigente, cancelado, completado
      switch (status) {
        case "vigente":
          return "primary";
        case "cancelado":
          return "danger";
        case "completado":
          return "success";
        default:
          return "secondary";
      }
    },
    loadYear() {
      for (let ano = 2017; ano <= d.getFullYear(); ano++) {
        this.selectOptions.years.push({ value: ano, text: ano });
      }
    },
    getSelectionSet() {
      this.$axios
        .get("/api/v1/client/process_select_input/")
        .then((res) => {
          const client_customers = res.data.client_customers;
          for (let idx in client_customers) {
            const item = {
              id: client_customers[idx]["value"],
              text: client_customers[idx]["text"]
            };
            this.options.listColumns["client_customer_name"].push(item);
          }
        })
        .catch((error) => console.log(error));
    }
  }
};
</script>

<style>
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }
  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
